<template>
    <div class="avatar-upload">
      <div class="text-center p-2">
        <label for="avatar">
          <div class="selfie-area">
            <img :src="files.length ? files[0].url : ''" v-show="files.length?true:false"  class="rounded-circle"/>
          </div>
          <h5 class="pt-2" v-show="selfieStatus === 'init'">{{$t('imagewall.selfieTipsInit1')}}<br/><br/>{{$t('imagewall.selfieTipsInit2')}}</h5>
          <h5 class="pt-2" v-show="selfieStatus === 'uploading'">{{$t('imagewall.selfieTipsUploading')}}</h5>
          <h5 class="pt-2" v-show="selfieStatus === 'failed'">{{$t('imagewall.selfieTipsFailed')}}</h5>
        </label>
      </div>
      <div class="text-center p-2"
        v-show="selfieStatus !== 'uploading'">
        <file-upload
          extensions="jpg,jpeg,png,webp"
          accept="image/*"
          name="image"
          class="btn btn-warning btn-lg"
          post-action="/api/selfie"
          :data="selfieUploadData"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload">
          {{selfieStatus === 'failed' ? $t('imagewall.selfieReupload') : $t('imagewall.selfieUpload')}}
        </file-upload>
      </div>
    </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
export default {
  components: {
    FileUpload
  },
  data () {
    return {
      files: [],
      selfieUploadData: {
        activity: ''
      },
      style: {
        photoArea: {}
      },
      selfieStatus: 'init',
      capture: 'camera'
    }
  },
  mounted () {
    this.selfieUploadData.activity = this.$route.params.id
    this.capture = false// 没有capture标签
    if (this.isWeixinBrowser()) {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        // Ios
      } else if (/(Android)/i.test(navigator.userAgent)) {
        // Android终端
        this.capture = 'camera'
      }
    }
  },
  methods: {
    isWeixinBrowser () {
      return !!(/micromessenger/.test(navigator.userAgent.toLowerCase()))
    },
    inputFile (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // 添加文件
      }
      if (newFile && oldFile) {
        // 更新文件
        // 开始上传
        if (newFile.active !== oldFile.active) {
          // console.log('Start upload', newFile.active, newFile)
          if (newFile.active) {
            this.selfieStatus = 'uploading'
          }
          // 限定最小字节
          // if (newFile.size >= 0 && newFile.size < 100 * 1024) {
          //   newFile = this.$refs.upload.update(newFile, {error: 'size'})
          // }
        }
        // 上传进度
        if (newFile.progress !== oldFile.progress) {
          this.selfieStatus = 'uploading'
          // console.log('progress', newFile.progress, newFile)
        }
        // 上传错误
        if (newFile.error !== oldFile.error) {
          this.selfieStatus = 'failed'
          // console.log('error', newFile.error, newFile)
        }
        // 上传成功
        if (newFile.success !== oldFile.success) {
          // console.log('success', newFile.success, newFile)
          if (newFile.success) {
            const res = JSON.parse(newFile.response)
            this.files = []
            this.selfieStatus = 'init'
            this.$emit('selectSuccess', res.result.photos)
          }
        }
      }
      // 自动上传
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert('Your choice is not a picture')
          return prevent()
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file)
        }
      }
    }
  }
}
</script>
